var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.showAddGpsDeviceModal },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "PlusIcon" },
                          }),
                          _vm._v(" New GPS Device "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: "12", md: "2", sm: "1" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm.paginatedFilteredDevices.length > 0
                        ? _c("b-table", {
                            attrs: {
                              striped: "",
                              hover: "",
                              responsive: "",
                              "per-page": _vm.perPage,
                              "current-page": _vm.currentPage,
                              items: _vm.filteredDevices,
                              fields: _vm.gps_fields,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDesc,
                              "sort-direction": _vm.sortDirection,
                              filter: _vm.filter,
                              "filter-included-fields": _vm.filterOn,
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDesc = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDesc = $event
                              },
                              filtered: _vm.onFiltered,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head(serialNumber)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.label)),
                                          ]),
                                          _c("b-form-input", {
                                            attrs: {
                                              placeholder:
                                                "Search Serial Number",
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.serialNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "serialNumber",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.serialNumber",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(installationDate)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.label)),
                                          ]),
                                          _c("DatePicker", {
                                            attrs: {
                                              range: "",
                                              placeholder: "Select Date Range",
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.dateRange,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "dateRange",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.dateRange",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(status)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.label)),
                                          ]),
                                          _c("b-form-select", {
                                            attrs: {
                                              options: _vm.statusFilterOptions,
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.status",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(actions)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "b-dropdown",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            variant: "link",
                                            "toggle-class": "p-0",
                                            "no-caret": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "button-content",
                                                fn: function () {
                                                  return [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "align-middle text-body",
                                                      attrs: {
                                                        icon: "MoreVerticalIcon",
                                                        size: "16",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showViewGpsDeviceModal(
                                                    data.item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "EyeIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-1",
                                                },
                                                [_vm._v("View")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEditGpsDeviceModal(
                                                    data.item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "EditIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-1",
                                                },
                                                [_vm._v("Edit")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.confirmDeleteGpsDevice(
                                                    data.item.gpsDeviceId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "TrashIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-1",
                                                },
                                                [_vm._v("Delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(installationDate)",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.beautifyDate(
                                              data.item.installationDate
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2130687036
                            ),
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mb-1",
                                },
                                [
                                  _c("b-spinner", {
                                    staticStyle: {
                                      width: "3rem",
                                      height: "3rem",
                                    },
                                    attrs: {
                                      variant: "success",
                                      label: "Spinning",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.filteredDevices.length,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalAddGpsDevice",
                  attrs: {
                    id: "modal-add-gps-device",
                    title: "Add New Gps Device",
                    "hide-footer": "",
                    centered: "",
                  },
                  on: { hide: _vm.resetForm },
                },
                [
                  _c("validation-observer", {
                    ref: "addGpsDeviceForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.addNewGpsDevice()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Serial Number",
                                      "label-for": "serialnumber",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Serial Number",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "serialnumber" },
                                                  model: {
                                                    value:
                                                      _vm.newGpsDevice
                                                        .serialNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newGpsDevice,
                                                        "serialNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newGpsDevice.serialNumber",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Installation Date",
                                      "label-for": "installationdate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Installation Date",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "installationdate",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newGpsDevice
                                                        .installationDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newGpsDevice,
                                                        "installationDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newGpsDevice.installationDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status",
                                      "label-for": "status",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Status",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "status",
                                                    options: _vm.statusOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newGpsDevice.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newGpsDevice,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newGpsDevice.status",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                    },
                                  },
                                  [_vm._v(" Add GPS Device ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalEditGpsDevice",
                  attrs: {
                    id: "modal-edit-gps-device",
                    title: "Edit Gps Device",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c("validation-observer", {
                    ref: "editGpsDeviceForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.updateGpsDevice()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Serial Number",
                                      "label-for": "editSerialNumber",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Serial Number",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "editSerialNumber",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editGpsDevice
                                                        .serialNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editGpsDevice,
                                                        "serialNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editGpsDevice.serialNumber",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Installation Date",
                                      "label-for": "editInstallationDate",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Installation Date",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "editInstallationDate",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editGpsDevice
                                                        .installationDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editGpsDevice,
                                                        "installationDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editGpsDevice.installationDate",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status",
                                      "label-for": "editStatus",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Status",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "editStatus",
                                                    options: _vm.statusOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editGpsDevice.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editGpsDevice,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editGpsDevice.status",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                  },
                                  [_vm._v(" Save Changes ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalViewGpsDevice",
                  attrs: {
                    id: "modal-view-gps",
                    title: "View Gps Device",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Serial Number",
                            "label-for": "viewSerialNumber",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewSerialNumber", readonly: "" },
                            model: {
                              value: _vm.viewGpsDevice.serialNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewGpsDevice, "serialNumber", $$v)
                              },
                              expression: "viewGpsDevice.serialNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Installation Date",
                            "label-for": "viewInstallationDate",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "viewInstallationDate",
                              value: _vm.beautifyDate(
                                _vm.viewGpsDevice.installationDate
                              ),
                              readonly: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Status", "label-for": "viewStatus" },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "viewStatus", readonly: "" },
                            model: {
                              value: _vm.viewGpsDevice.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.viewGpsDevice, "status", $$v)
                              },
                              expression: "viewGpsDevice.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }